/**
 * Time-of-day greeting logic shared between the web ambient hook
 * (`useTimeOfDay` in @healthos/ui) and the mobile greeting composer. The
 * slot boundaries (5/12/17/21) are the canonical rule; both clients read
 * them from here so the greeting lead cannot drift from the ambient
 * palette.
 *
 *   05:00 -> 12:00  morning
 *   12:00 -> 17:00  afternoon
 *   17:00 -> 21:00  evening
 *   21:00 -> 05:00  night
 */
export function greetingSlotForDate(date) {
    const hour = date.getHours();
    if (hour < 5 || hour >= 21)
        return "night";
    if (hour < 12)
        return "morning";
    if (hour < 17)
        return "afternoon";
    return "evening";
}
export function greetingLeadForDate(date) {
    const slot = greetingSlotForDate(date);
    if (slot === "night")
        return "Good night";
    if (slot === "morning")
        return "Good morning";
    if (slot === "afternoon")
        return "Good afternoon";
    return "Good evening";
}
export function extractGreetingName(title) {
    const trimmed = title?.trim();
    if (!trimmed)
        return null;
    const commaIndex = trimmed.indexOf(",");
    if (commaIndex < 0)
        return null;
    const name = trimmed.slice(commaIndex + 1).trim();
    return name.length > 0 ? name : null;
}
export function normalizeGreetingName(name) {
    const firstName = name?.trim().split(/\s+/)[0];
    if (!firstName)
        return null;
    return /[.!?]$/.test(firstName) ? firstName : `${firstName}.`;
}
export function timedGreetingTitle(title, date, fallbackName) {
    const name = extractGreetingName(title) ?? normalizeGreetingName(fallbackName) ?? "friend.";
    return `${greetingLeadForDate(date)}, ${name}`;
}
//# sourceMappingURL=time-greeting.js.map